module.exports = __webpack_public_path__ + "img/horizontal_5_1_2.86f85482.png";